import { Tooltip, Typography, type TypographyProps } from '@mui/material';

interface TruncatedTextWithTooltipProps {
  value: string;
  size: number;
  sx?: TypographyProps['sx'];
  variant?: TypographyProps['variant'];
  color?: TypographyProps['color'];
}

function TruncatedTextWithTooltip(props: TruncatedTextWithTooltipProps) {
  const { value, size, sx, variant, color } = props;

  const shouldTruncate = value.length > size;
  const displayedText = shouldTruncate ? `${value.slice(0, size)}...` : value;

  return (
    <Tooltip title={shouldTruncate ? value : ''}>
      <Typography
        sx={{
          ...sx,
          backgroundColor: 'inherit',
        }}
        variant={variant}
        color={color}
      >
        {displayedText}
      </Typography>
    </Tooltip>
  );
}

export default TruncatedTextWithTooltip;
